import { Switch, Upload, message } from "antd";
import React, { useState } from "react";
import { Form, FormGroup } from "react-bootstrap";
import { DropAudio } from "../../../../../../constants/svg";
import CustomUploader from "../../../../../Common/CustomUploader";

const AudioUpload = ({
  handleChange,
  fileList,
  resetField,
  handleSwitch,
  switchDefaultValue,
  linkDefaultValue,
}) => {
  const [switchValue, setSwitchValue] = useState(false);

  const handleSwitchChange = (checked) => {
    resetField("uploadAudio");
    setResourceLink("");
    setSwitchValue(checked);
    handleSwitch(checked);
  };

  // Only allow video, pdf and audio files
  const UploadProps = {
    name: "file",
    accept: "audio/*",
    beforeUpload: (file) => {
      const isAudio = file.type.startsWith("audio/");
      const isZip = file.name.toLowerCase().endsWith(".zip");

      if (isZip) {
        message.error("ZIP files are not allowed.");
        return Upload.LIST_IGNORE; // prevent upload
      }

      if (!isAudio) {
        message.error("You can only upload audio files!");
        return Upload.LIST_IGNORE;
      }

      return true;
    },
  };

  // Resource Link Request
  const [resourceLink, setResourceLink] = useState("");

  const handleInputLink = (event) => {
    setResourceLink(event.target.value);
    handleChange(event.target.value);
  };

  return (
    <>
      <div className="uploadHeader d-flex justify-content-between align-items-center">
        <div className="title">Upload an MP3 or link to an audio source.</div>
        <p className="m-0 link-to-resource-label">
          Link to resource instead
          <Switch
            checked={switchDefaultValue || switchValue}
            onChange={handleSwitchChange}
            className="custom-ml-05"
          />
        </p>
      </div>
      {!switchValue && !switchDefaultValue ? (
        <div className="addLink-Box resource-audio">
          <CustomUploader
            {...UploadProps}
            showUploadList={{
              showDownloadIcon: false,
              showPreviewIcon: false,
            }}
            listType="text"
            fileList={fileList == "" ? [] : [fileList]}
            onChange={(e) => {
              const fileList = e.fileList;
              handleChange(
                !fileList.length
                  ? ""
                  : fileList.length > 1
                    ? fileList[1]
                    : fileList[0],
              );
            }}
            className="three-type-upload"
            beforeUpload={() => {
              /* update state here */
              return false;
            }}
          >
            <DropAudio />
          </CustomUploader>
        </div>
      ) : (
        <div className="uploaderBox floatedLabel">
          <FormGroup className="form-label-group">
            <Form.Label htmlFor="resourceLink">Resource Link</Form.Label>
            <Form.Control
              type="link"
              id="resourceLink"
              placeholder="https://"
              value={linkDefaultValue || resourceLink}
              onChange={handleInputLink}
              required
            />
          </FormGroup>
        </div>
      )}
    </>
  );
};

export default AudioUpload;
